var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToDo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H29C35.6274 0 41 5.37258 41 12V29C41 35.6274 35.6274 41 29 41H12C5.37258 41 0 35.6274 0 29V12Z",
    fill: "#8C52FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4585 22.3373L18.2246 26.2831C17.9376 26.4397 17.6186 26.5137 17.2979 26.4979C16.9773 26.4822 16.6657 26.3773 16.3927 26.1932C16.1197 26.0091 15.8943 25.7519 15.7381 25.4461C15.5819 25.1402 15.4999 24.7959 15.5 24.4457V16.5543C15.4999 16.2041 15.5819 15.8598 15.7381 15.5539C15.8943 15.2481 16.1197 14.9909 16.3927 14.8068C16.6657 14.6227 16.9773 14.5178 17.2979 14.5021C17.6186 14.4863 17.9376 14.5603 18.2246 14.7169L25.4585 18.6627C25.7714 18.8331 26.0346 19.0953 26.2186 19.4199C26.4026 19.7444 26.5 20.1184 26.5 20.5C26.5 20.8816 26.4026 21.2556 26.2186 21.5801C26.0346 21.9047 25.7714 22.1669 25.4585 22.3373Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToDo);
export default __webpack_public_path__ + "static/media/to-do.60fed440e203b6d80601b578285ea394.svg";
export { ForwardRef as ReactComponent };